var SPScript = require("spscript");

if (window._natpAnalytics){
    // Setup Google Analytics
    require("./googleAnalytics").setup();
    // Setup Qualaroo
    require("./qualaroo").setup();    
}

var invoked = false;
global.natpOnLoad = function() {
    require("./events").bind();
};

// invoke natpOnLoad when page is ready. Make sure the global array is there before trying to push
window._spBodyOnLoadFunctionNames.push("natpOnLoad");

var toggleRibbon = function() {
    //Render Ribbon Bar (Logged-in + AD User ONLY)
    if (natp.utils.isWindowsUser()){
        $("#suiteBar").show();
        $("#s4-ribbonrow").show();
    }
};

var hideLeftNavLinks = function() {
    //Hide "Recent" left nav group
    $(".ms-core-listMenu-item:contains('Recent')").parent().hide();
    //Hide "Site Contents" left nav link	
    $(".ms-splinkbutton-text:contains('Site Contents')").parent().hide();
}

exports.domReady = () => {
    toggleRibbon();
    hideLeftNavLinks();
    require("./components").create();
};


// WEBPACK FOOTER //
// ./src/scripts/onload/index.js